import env from '@/helpers/env'
import capacitor from '@/helpers/capacitor'

const persistentStorage = {
  async load () {
    if (env.isCap) {
      return await capacitor.request('getStore') || {}
    } else {
      return JSON.parse(localStorage.getItem(env.appName) || '{}')
    }
  },
  async save (data) {
    if (env.isCap) {
      await capacitor.request('setStore', data)
    } else {
      localStorage.setItem(env.appName, JSON.stringify(data))
    }
  },
  async clear () {
    if (env.isCap) {
      await capacitor.request('clearStore')
    } else {
      localStorage.removeItem(env.appName)
    }
  }
  
}

export {
  persistentStorage
}